import { FC, useMemo } from "react";
import { Item, ItemProps } from ".";

interface RadioOption {
    label: string;
    value: string;
}

interface RadioProps extends ItemProps {
    value?: string;
    onChange?: (value: string) => void;
    options: RadioOption[];
}

const Radio: FC<RadioProps> = ({ value, onChange, col, error, label, required, options, itemClassName }) => {
    const wrapperClass = useMemo(() => col ? `mb-2 md:col-span-${col}` : "mb-2", [col]);
    return (
        <Item col={col} label={label} required={required} error={error} itemClassName={itemClassName}>
            <div className={wrapperClass + " flex flex-col space-y-1"}>
                {options.map(opt => (
                    <label key={opt.value} className="inline-flex items-center space-x-2 cursor-pointer">
                        <input
                            type="radio"
                            name={label?.toString() || "radio-group"}
                            value={opt.value}
                            checked={value === opt.value}
                            onChange={() => onChange && onChange(opt.value)}
                            className={`w-4 h-4 border rounded cursor-pointer ${error ? "border-red-500" : "border-gray-300"}`}
                        />
                        <span className="text-gray-700">{opt.label}</span>
                    </label>
                ))}
            </div>
        </Item>
    );
};

export default Radio;